import BlockObserver from "./BlockObserver";
import Splide from "@splidejs/splide";

export default class PostsCarousel {
    init(block) {
        this.paginatePrev        = block.querySelectorAll('[data-paginate="prev"]');
        this.paginateNext        = block.querySelectorAll('[data-paginate="next"]');
        let main                 = null;

        main = new Splide(block.querySelector('.splide'), {
            type        : 'slide',
            rewind      : false,
            perPage     : 1,
            perMove     : 1,
            autoWidth   : true,
            gap         : 32,
            padding     : 0,
            start       : 0,
            pagination  : false,
            arrows      : false,
            breakpoints: {
                767: {
                    gap: 24,
                },
                1023: {
                    gap: 32,
                }
            }
        });

        main.mount();


        if(this.paginatePrev) {
            this.paginatePrev.forEach((paginatePrev) => {
                paginatePrev.addEventListener('click', (event) => {
                    main.go('-${1}');
                });
            })
        }
        if(this.paginateNext) {
            this.paginateNext.forEach((paginateNext) => {
                paginateNext.addEventListener('click', (event) => {
                    main.go('+${1}');
                });
            })
        }
    }
}